import React, { useCallback } from 'react';
import { connect } from 'react-redux';

import { LoadingMessage } from 'js/components';
import { listWorkspaceRubrics } from 'js/actions/rubric-actions';
import {
  lookupOrgRubricWeightSchemes,
  updateOrgRubricWeightScheme,
} from 'js/actions/org-actions';

import OrgRubricSchemes from '../components/ManageOrg/OrgRubricSchemes';

function OrgRubricSchemesContainer({
  organization,
  loading: orgLoading,
  errorLoading,
  lookupOrgRubricWeightSchemes,
  updateOrgRubricWeightScheme,
  listWorkspaceRubrics,
}) {
  const handlePersistTeamScheme = useCallback(
    (orgId, rubricId, teamId, body) =>
      updateOrgRubricWeightScheme(orgId, rubricId, teamId, body),
    [updateOrgRubricWeightScheme]
  );

  if (!organization && !errorLoading && orgLoading) {
    return <LoadingMessage iconSize="2x">Loading organization…</LoadingMessage>;
  }

  if (!organization) {
    return null;
  }

  return (
    <OrgRubricSchemes
      organization={organization}
      lookupOrgRubricWeightSchemes={lookupOrgRubricWeightSchemes}
      listWorkspaceRubrics={listWorkspaceRubrics}
      onPersistTeamScheme={handlePersistTeamScheme}
    />
  );
}

export default connect(null, {
  listWorkspaceRubrics,
  lookupOrgRubricWeightSchemes,
  updateOrgRubricWeightScheme,
})(OrgRubricSchemesContainer);
